import { Controller } from '@hotwired/stimulus';

// Champs du formulaire selon le type choisi (champ d'id `type`, relu à chaque
// changement dans le formulaire). `schemas[type]` :
// un réglage par champ de `fields` (ids) : true (champ libre), false (champ
// vidé et masqué, la valeur vide est envoyée) ou une valeur imposée (posée,
// champ verrouillé) ; sans type choisi, tous masqués.
export default class extends Controller {
    static values = { type: String, schemas: Object, fields: Array };

    connect() {
        this.apply();
    }

    apply() {
        const type = this.typeValue && document.getElementById(this.typeValue);
        if (!type) return;
        const schema = this.schemasValue[type.value];
        this.fieldsValue.forEach((id, index) => {
            const field = document.getElementById(id);
            if (!field) return;
            const block = field.closest('.form-field') || field.parentElement;
            const option = schema ? schema[index] : false;
            if (option === true) {
                this.show(block, { locked: false });
            } else if (option === false) {
                this.clear(field);
                block.hidden = true;
            } else {
                this.set(field, option);
                this.show(block, { locked: true });
            }
        });
    }

    show(block, { locked }) {
        block.hidden = false;
        block.inert = locked;
        block.classList.toggle('opacity-60', locked);
    }

    clear(field) {
        if (field.type === 'checkbox') {
            field.checked = false;
        } else if (field.tagName === 'SELECT') {
            field.value = '';
            field.dispatchEvent(new CustomEvent('combobox:render', { bubbles: true }));
        } else {
            field.value = '';
        }
    }

    set(field, value) {
        if (field.type === 'checkbox') {
            field.checked = Boolean(value);
        } else {
            field.value = String(value);
            if (field.tagName === 'SELECT') field.dispatchEvent(new CustomEvent('combobox:render', { bubbles: true }));
        }
    }
}
